import { SSRGlobal } from "../qecomps/Context";

export default props => {

    let z = SSRGlobal()
    var initX = 0, initY = 0;
    var endX = 0, endY = 0;
    var touchStartX = 0;
    var touchEndX = 0;
    var touchStartY = 0;
    var touchEndY = 0;
    var hpvc = null;
    var videl = null;
    var vidbar = null;
    var vidtimer = null;
    var newtime = null;
    var toucher = false
    var firsttime = true;
    var iframeimg = global.cdn("/files/youtube1.svg")
    var subel = null

    var containerwidth = 0;
    var dragtopercent = 0;
    var mousedown = false;

    var containerwidth = 0;

    var seekedtimer = 0;

    let stoptimer = false;

    let iswide = false

    if (typeof window != "undefined") {
        if (!videl) {
            videl = document.getElementById("hpv_" + props.index)
        }
        iswide = (window?.innerWidth > 800) || false
    }



    props.interval.run = () => {
        if (stoptimer) {
            return;
        }

        if (!videl) {
            videl = document.getElementById("hpv_" + props.index)
        }
        if (!vidbar) {
            vidbar = document.getElementById("hbar_" + props.index)
        }
        if (!vidtimer) {
            vidtimer = document.getElementById("htimer_" + props.index)
        }
        if (vidbar && vidtimer) {
            var h = Math.floor(videl.currentTime / 3600).toString().padStart(2, "0");
            var m = Math.floor(videl.currentTime % 3600 / 60).toString().padStart(2, "0");;
            var s = Math.floor(videl.currentTime % 3600 % 60).toString().padStart(2, "0");;
            vidtimer.innerHTML = h + ":" + m + ":" + s
            vidbar.style.width = Math.floor(100 * (videl.currentTime / videl.duration)) + "%"
            if (Math.abs(videl.currentTime - videl.duration) < 1) {
                videl.currentTime = 0
            }
        }

        if (videl.textTracks[0]) {
            if (document.fullscreenElement == videl) {
                videl.textTracks[0].mode = 'showing'
            }
            else {
                if (videl.textTracks.length > 0) {
                    videl.textTracks[0].mode = 'hidden'
                }
            }
        }



        if (!subel) {
            subel = document.getElementById("hsub_" + props.index)
        }
        if (videl.textTracks.length == 0 || !videl.textTracks[0].activeCues) {
            return
        }
        var cue = videl.textTracks[0].activeCues[0];

        if (cue) {
            if (subel.innerHTML != cue.text) {
                subel.innerHTML = cue.text
            }
        }
    };


    var applyseek = () => {
        if (!videl) {
            videl = document.getElementById("hpv_" + props.index)
        }
        if (videl && !isNaN(seekedtimer) && isFinite(seekedtimer))
            videl.currentTime = seekedtimer
    }
    var ontimerseek = (p) => {
        if (isNaN(p)) {
            return;
        }
        if (!videl) {
            videl = document.getElementById("hpv_" + props.index)
        }
        seekedtimer = Math.floor(p * videl.duration / 100);
        var h = Math.floor(seekedtimer / 3600).toString().padStart(2, "0");
        var m = Math.floor(seekedtimer % 3600 / 60).toString().padStart(2, "0");;
        var s = Math.floor(seekedtimer % 3600 % 60).toString().padStart(2, "0");;
        document.getElementById("htimer_" + props.index).innerHTML = h + ":" + m + ":" + s
    }


    console.log("video render...")

    return <c-xc className={props.show ? z.styles.expmedia : z.styles.none} style={{
        position: "relative",
        // height: '100%',
        // padding: (global.window || {}).innerWidth > 800 ? "30px 0" : null,
        // minHeight: (global.window || {}).innerWidth > 800 ? null : (75000 / 1024) + "vw",
        width: "100%"
    }}>

        {/* {props.item.subtitle ? <Bold><f-cc id={"hsub_" + props.index} class={z.styles.subtx}
            style={{ bottom: 33, backgroundColor: "#000a", fontSize: 13, }} ></f-cc></Bold> : null} */}

        {/* <c-cc id={"hpvc_" + props.index} style={{
            backgroundColor: "#000000aa",
            // height: '70vw', maxHeight: 'calc(min(330px , 60vh))',
            width: "100%", position: "absolute", display: "none"
        }}>
            <span style={{ color: "white", fontSize: 19, fontWeight: "bold" }}></span>
            <span style={{ color: "white", fontSize: 19, fontWeight: "bold" }}><span></span><span style={{ fontSize: 14 }}></span></span>
        </c-cc> */}


        {/* <f-x id={"htimer_" + props.index} style={{
            color: "white", fontSize: 11, bottom: 33, left: 0, position: "absolute",
            backgroundColor: "#000000aa", padding: "2px 5px", borderRadius: 3
        }}>
            00:00:00
        </f-x> */}
        <f-cc id={"hbarc_" + props.index} style={{
            position: "absolute", backgroundColor: "green",
            width: "100%", height: 30, bottom: 29, opacity: 0.01, zIndex: 1000, direction: "ltr"
        }}
            onTouchStart={(e) => {
                // stoptimer = true
                // containerwidth = parseFloat(window.getComputedStyle(document.getElementById("hbarc_" + props.index)).width.replace("px", ""))
                // var bcr = (e.target as any).getBoundingClientRect();
                // var x = e.targetTouches[0].clientX - bcr.x;
                // mousedown = true
                // document.getElementById("hbar_" + props.index).style.width = x + "px"
                // dragtopercent = (x * 100 / containerwidth);
                // if (isNaN(dragtopercent)) {
                //     stoptimer = false
                // }
                // else {
                //     ontimerseek?.(dragtopercent)
                // }
            }}
            onMouseDown={(e) => {
                // stoptimer = true
                // containerwidth = parseFloat(window.getComputedStyle(document.getElementById("hbarc_" + props.index)).width.replace("px", ""))
                // mousedown = true
                // document.getElementById("hbar_" + props.index).style.width = e.nativeEvent.offsetX + "px"
                // dragtopercent = (e.nativeEvent.offsetX * 100 / containerwidth);
                // if (isNaN(dragtopercent)) {
                //     stoptimer = false
                // }
                // else {
                //     ontimerseek?.(dragtopercent)
                // }
                // e.stopPropagation()
            }}
            onMouseUp={() => {
                // stoptimer = false
                // mousedown = false
                // applyseek?.();
            }}
            onTouchEnd={() => {
                // setTimeout(() => {
                //     stoptimer = false
                // }, 2000)
                // mousedown = false
                // applyseek?.();
            }}

            onMouseMove={(e) => {
                // if (mousedown) {
                //     document.getElementById("hbar_" + props.index).style.width = e.nativeEvent.offsetX + "px"
                //     dragtopercent = (e.nativeEvent.offsetX * 100 / containerwidth);
                //     ontimerseek?.(dragtopercent)
                // }
            }}
            onTouchMove={(e) => {
                // var bcr = (e.target as any).getBoundingClientRect();
                // var x = e.targetTouches[0].clientX - bcr.x;
                // if (mousedown) {
                //     document.getElementById("hbar_" + props.index).style.width = x + "px"
                //     dragtopercent = (x * 100 / containerwidth);
                //     ontimerseek?.(dragtopercent)
                // }
            }} />
        <f-c style={{ direction: "ltr" }}>
            <f-cc id={"hbar_" + props.index}
                style={{
                    position: "absolute", backgroundColor: "forestgreen",
                    width: "0%", height: 4, bottom: 29, direction: "ltr"
                }} />
        </f-c>

        <video id={"hpv_" + props.index} src={global.cdn(props.item.video)}
            muted={false}
            playsInline
            controls
            preload="metadata"
            // poster="thumbnail.jpg"
            // disablePictureInPicture
            className={props.show ? "" : z.styles.none}
            style={{
                maxHeight: true ? '420px' : '100%',
                width: "100%", 
                // objectFit: "contain",
                // height: "100%",
                // paddingBottom: iswide ? 0 : 30,
            }}

            onTouchStart={(e) => {
                toucher = true
                touchStartX = e.touches[0].clientX;
                touchEndX = e.touches[0].clientX
                touchStartY = e.touches[0].clientY;
                touchEndY = e.touches[0].clientY
                e.stopPropagation()
            }}
            onTouchMove={(e) => {
                touchEndY = e.touches[0].clientY
                touchEndX = e.touches[0].clientX
            }}
            onTouchEnd={(e) => {

                if (!videl) {
                    videl = document.getElementById("hpv_" + props.index)
                }
                if (!hpvc) {
                    hpvc = document.getElementById("hpvc_" + props.index)
                }
                if (newtime != null) {
                    if (newtime > videl.duration - 5) {
                        newtime = videl.duration - 5
                    }
                    videl.currentTime = newtime;
                    videl.play();
                }
                else {
                    if (Math.abs(touchStartX - touchEndX) == 0 && Math.abs(touchStartY - touchEndY) < 20) {
                        if (e.currentTarget.paused) {
                            e.currentTarget.play()
                        }
                        else {
                            e.currentTarget.pause()
                        }
                    }
                }
                touchStartX = 0, touchEndX = 0, initY = 0, initX = 0, endX = 0, endY = 0, newtime = null
                // document.getElementById("hpvc_" + props.index).style.display = "none"
            }}
            onMouseDown={(e) => {
                // e.preventDefault()
                e.stopPropagation()

                if (toucher) {
                    return;
                }
                newtime = null
                if (firsttime) {
                    firsttime = false
                    return
                }
                initX = e.clientX
                initY = e.clientY
                endX = e.clientX
                endY = e.clientY
            }}
            onMouseUp={(e) => {
                e.preventDefault()
                e.stopPropagation()

                if (toucher) {
                    return;
                }
                if (newtime != null) {
                    if (newtime > videl.duration - 5) {
                        newtime = videl.duration - 5
                    }
                    videl.currentTime = newtime;
                    videl.play();
                }

                if (Math.abs(endX - initX) + Math.abs(endY - initY) == 0) {
                    if (e.currentTarget.paused) {
                        e.currentTarget.play()
                    }
                    else {
                        e.currentTarget.pause()
                    }
                }
                initX = 0;
                initY = 0;
                // document.getElementById("hpvc_" + props.index).style.display = "none"
            }}
        >
            {props.item.subtitle ? <track default src={global.cdn(props.item.subtitle)} /> : null}
        </video>

        {/* <f-cc style={{ position: "absolute", backgroundColor: "green", width: "100%", height: 4, bottom: 29, opacity: 0.5 }} /> */}

        {/* <div style={{ height: 30, backgroundColor: "#000", width: "100%", marginTop: -7, borderRadius: 5 }}></div> */}
        {props.children}
    </c-xc>
}